import VideoIcon from "assets/images/icons/video-icon.svg";

export const VideoContent = ({ label, redirectTo, onSetUrl }) => {
  return (
    <div
      onClick={() => onSetUrl(redirectTo, label)}
      className="attachement-btn"
      style={{ cursor: "pointer" }}
    >
      <img src={VideoIcon} alt="icon" />
      <span className="attachement-btn-txt">{label}</span>
    </div>
  );
};
